import { useState } from 'react';
import WebsiteSubTab from './performance/WebsiteSubTab';
import RankingsSubTab from './performance/RankingsSubTab';
import GbpSubTab from './performance/GbpSubTab';
import ListingsTab from './ListingsTab';
import type { Franchisee } from '../types';

type Props = { franchisee: Franchisee | null };

type SubTabId = 'perf-website' | 'perf-rankings' | 'perf-gmb' | 'perf-listings';

const SUBS: ReadonlyArray<{ id: SubTabId; label: string }> = [
  { id: 'perf-website', label: 'Website' },
  { id: 'perf-rankings', label: 'Rankings' },
  { id: 'perf-gmb', label: 'Google Business Profile' },
  { id: 'perf-listings', label: 'Directory Listings' },
];

export default function PerformanceTab({ franchisee }: Props) {
  const [sub, setSub] = useState<SubTabId>('perf-website');

  if (!franchisee) {
    return (
      <div className="tab-placeholder">
        <h3>Organic Performance</h3>
        <p>Select a franchisee to view their organic performance metrics.</p>
      </div>
    );
  }

  return (
    <>
      <div className="perf-sub-tabs">
        {SUBS.map((s) => (
          <button
            key={s.id}
            className={`perf-sub-btn ${sub === s.id ? 'active' : ''}`}
            onClick={() => setSub(s.id)}
          >
            {s.label}
          </button>
        ))}
      </div>

      {sub === 'perf-website' && <WebsiteSubTab af={franchisee.af_number} />}
      {sub === 'perf-rankings' && <RankingsSubTab franchisee={franchisee} />}
      {sub === 'perf-gmb' && <GbpSubTab af={franchisee.af_number} />}
      {sub === 'perf-listings' && <ListingsTab af={franchisee.af_number} />}
    </>
  );
}
